var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M8.26666 22.8667C8.05333 22.7267 7.77998 22.7067 7.55332 22.8267C7.55332 22.8267 7.55332 22.8267 7.54667 22.8267C6.53332 23.3467 6.41999 22.08 5.48668 22.3533C4.64668 22.6 2.78666 23.2267 3.61999 23.8067C4.25331 24.2534 4.98667 23.76 5.45332 24.0333C6.35331 24.5533 6.30001 24.7133 7.06 24.4667C8.50665 23.9933 8.18665 24.5467 9.22667 24.74C9.98001 24.88 10.8733 24.6267 11.2933 24.2C10.2133 23.9133 9.19332 23.46 8.26666 22.8667Z",
    fill: "url(#paint0_linear_1414_3989)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94006 22.6466C7.81336 22.6999 7.68669 22.7599 7.54669 22.8266C6.53337 23.3466 6.46005 22.3533 5.4867 22.3533C4.58671 22.3533 2.78671 23.2266 3.62004 23.8066C4.25337 24.2533 4.98672 23.76 5.45338 24.0333C6.35337 24.5533 6.30003 24.7133 7.06005 24.4666C8.50671 23.9933 8.1867 24.5466 9.22669 24.74C9.98003 24.88 10.8734 24.6266 11.2934 24.1999C10.08 23.8799 8.94669 23.3466 7.94006 22.6466Z",
    fill: "url(#paint1_linear_1414_3989)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24.5333C19.8911 24.5333 24.6667 19.7577 24.6667 13.8666C24.6667 7.97558 19.8911 3.19995 14 3.19995C8.10902 3.19995 3.33337 7.97558 3.33337 13.8666C3.33337 19.7577 8.10902 24.5333 14 24.5333Z",
    fill: "url(#paint2_radial_1414_3989)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.6667 13.8666C24.6667 19.7599 19.8934 24.5 14 24.5333C8.14671 24.5599 3.36003 19.78 3.33336 13.8666C3.3067 7.97327 8.1067 3.19995 14 3.19995C19.8934 3.19995 24.6667 7.97327 24.6667 13.8666Z",
    fill: "url(#paint3_radial_1414_3989)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4468 12.0201C10.8001 11.6667 8.94008 11.8067 8.09343 12.3601C7.65341 12.6467 5.96008 12.8467 6.81341 21.7534C7.74007 22.6067 8.8201 23.2934 10.0001 23.7734C7.40677 17.5534 9.9401 12.5267 10.4468 12.0201Z",
    fill: "url(#paint4_linear_1414_3989)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.28 21.4868C12.5133 21.0401 13.14 20.7468 14 20.7468C14.86 20.7468 15.4933 21.0401 16.72 21.4868C17.8667 21.9001 18.5067 21.0401 18.38 19.7868C17.9333 17.1468 16.0133 15.1201 14 15.1201C12.0467 15.1201 10.18 16.9868 9.66 19.4934C9.39334 20.9001 10.0467 21.9268 11.28 21.4868Z",
    fill: "url(#paint5_radial_1414_3989)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9734 18.3535C17.1934 16.4468 15.6267 15.1201 14.0001 15.1201C12.3734 15.1201 10.8067 16.4468 10.0267 18.3535C10.0467 18.3134 10.5467 17.2734 11.5801 17.4934C12.6334 17.7201 14.0001 17.7468 14.0001 17.7468C14.0001 17.7468 15.3601 17.7134 16.4201 17.4934C17.4801 17.2734 17.9734 18.3535 17.9734 18.3535Z",
    fill: "url(#paint6_linear_1414_3989)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 17.1001C14.8667 17.1001 15.7334 17.0601 16.5934 16.9734C16.5134 16.8801 16.4334 16.7934 16.3467 16.7068C15.6401 15.9934 14.8067 15.6001 14.0001 15.6001C13.1934 15.6001 12.3601 15.9934 11.6534 16.7068C11.5667 16.7934 11.4867 16.8801 11.4067 16.9734C12.2667 17.0601 13.1334 17.1001 14.0001 17.1001Z",
    fill: "url(#paint7_radial_1414_3989)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.0535C12.7533 19.0535 10.9933 19.5868 10.5867 21.1735C10.8867 21.0868 11.24 20.9468 11.5 20.8468C12.28 20.5468 13.16 20.2668 13.9933 20.2668C14.8267 20.2668 15.7066 20.6068 16.4867 20.9135C16.7467 21.0135 17.1066 21.1535 17.4067 21.2401C17.0133 19.6201 15.2467 19.0535 14 19.0535Z",
    fill: "url(#paint8_radial_1414_3989)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44009 8.84662C7.46676 9.27331 7.9401 9.5133 8.73341 9.4733C9.40675 9.43329 10.8668 8.97997 11.8134 7.61329C11.9868 7.35996 11.6934 7.24663 11.5134 7.4133C10.9134 7.97995 9.27343 8.75996 7.95344 8.68664C7.42676 8.65997 7.44009 8.84662 7.44009 8.84662Z",
    fill: "url(#paint9_linear_1414_3989)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79329 10.7067C9.79329 10.7067 11.72 10.6067 12.48 11.8534C12.5266 11.9334 12.56 12.0201 12.5733 12.1067C12.6 12.2868 12.46 12.4934 12.0933 12.3734C9.82661 11.6201 8.66664 12.1734 7.78663 12.5734C7.44664 12.7267 7.06661 12.4001 7.19328 12.1201C7.81995 10.7067 9.79329 10.7067 9.79329 10.7067Z",
    fill: "url(#paint10_radial_1414_3989)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79337 10.7067C9.79337 10.7067 11.7201 10.6067 12.48 11.8534C12.5067 11.9001 12.5334 11.9468 12.5467 12.0001C11.4 11.0467 9.82669 11.1334 9.82669 11.1334C9.82669 11.1334 8.36005 11.0534 7.26672 11.9734C7.96004 10.7067 9.79337 10.7067 9.79337 10.7067Z",
    fill: "url(#paint11_linear_1414_3989)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.56 8.84662C20.5333 9.27331 20.06 9.5133 19.2667 9.4733C18.5933 9.43329 17.1333 8.97997 16.1866 7.61329C16.0133 7.35996 16.3066 7.24663 16.4866 7.4133C17.0866 7.97995 18.7266 8.75996 20.0467 8.68664C20.5733 8.65997 20.56 8.84662 20.56 8.84662Z",
    fill: "url(#paint12_linear_1414_3989)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2068 10.7067C18.2068 10.7067 16.2801 10.6067 15.5201 11.8534C15.4734 11.9334 15.4401 12.0201 15.4268 12.1067C15.4001 12.2868 15.5401 12.4934 15.9067 12.3734C18.1734 11.6201 19.3334 12.1734 20.2134 12.5734C20.5534 12.7267 20.9334 12.4001 20.8067 12.1201C20.1801 10.7067 18.2068 10.7067 18.2068 10.7067Z",
    fill: "url(#paint13_radial_1414_3989)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2066 10.7067C18.2066 10.7067 16.2799 10.6067 15.5199 11.8534C15.4933 11.9001 15.4666 11.9468 15.4532 12.0001C16.5999 11.0467 18.1733 11.1334 18.1733 11.1334C18.1733 11.1334 19.6399 11.0534 20.7332 11.9734C20.0399 10.7067 18.2066 10.7067 18.2066 10.7067Z",
    fill: "url(#paint14_linear_1414_3989)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1134 23.8199C5.61342 12.4866 7.57342 12.4333 8.0734 12.1666C8.96009 11.6866 10.5134 11.5199 10.4467 12.0199C10.3734 12.5799 7.44676 13.12 8.74673 23.8199",
    fill: "url(#paint15_linear_1414_3989)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M8.26664 22.8667C8.05331 22.7267 7.77996 22.7067 7.5533 22.8268C7.5533 22.8268 7.5533 22.8268 7.54665 22.8268C6.5333 23.3468 6.45997 22.3668 5.48666 22.3534C4.65331 22.3401 2.78664 23.2267 3.61997 23.8068C4.25333 24.2534 4.98665 23.7601 5.4533 24.0334C6.35333 24.5534 6.29999 24.7134 7.05998 24.4668C8.50663 23.9934 8.18666 24.5467 9.22665 24.7401C9.97999 24.8801 10.8733 24.6267 11.2933 24.2001C10.2133 23.9134 9.1933 23.4601 8.26664 22.8667Z",
    fill: "url(#paint16_linear_1414_3989)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M6.1134 23.8199C5.61342 12.4866 7.57342 12.4333 8.0734 12.1666C8.96009 11.6866 10.5134 11.5199 10.4467 12.0199C10.3734 12.5799 7.44676 13.12 8.74673 23.8199",
    fill: "url(#paint17_linear_1414_3989)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M6.1134 23.8199C5.61342 12.4866 7.57342 12.4333 8.0734 12.1666C8.96009 11.6866 10.5134 11.5199 10.4467 12.0199C10.3734 12.5799 7.44676 13.12 8.74673 23.8199",
    fill: "url(#paint18_linear_1414_3989)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1134 23.8199C5.61342 12.4866 7.57342 12.4333 8.0734 12.1666C8.96009 11.6866 10.5134 11.5199 10.4467 12.0199C10.3734 12.5799 7.44676 13.12 8.74673 23.8199",
    fill: "url(#paint19_linear_1414_3989)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M19.7333 22.8667C19.9467 22.7267 20.22 22.7067 20.4467 22.8267C20.4467 22.8267 20.4467 22.8267 20.4533 22.8267C21.4667 23.3467 21.58 22.08 22.5133 22.3533C23.3533 22.6 25.2133 23.2267 24.38 23.8067C23.7467 24.2534 23.0134 23.76 22.5467 24.0333C21.6467 24.5533 21.7 24.7133 20.94 24.4667C19.4933 23.9933 19.8133 24.5467 18.7733 24.74C18.02 24.88 17.1267 24.6267 16.7067 24.2C17.7867 23.9133 18.8067 23.46 19.7333 22.8667Z",
    fill: "url(#paint20_linear_1414_3989)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.06 22.6466C20.1867 22.6999 20.3133 22.7599 20.4533 22.8266C21.4667 23.3466 21.54 22.3533 22.5133 22.3533C23.4133 22.3533 25.2133 23.2266 24.38 23.8066C23.7467 24.2533 23.0133 23.76 22.5467 24.0333C21.6467 24.5533 21.7 24.7133 20.94 24.4666C19.4933 23.9933 19.8133 24.5466 18.7733 24.74C18.02 24.88 17.1267 24.6266 16.7067 24.1999C17.92 23.8799 19.0533 23.3466 20.06 22.6466Z",
    fill: "url(#paint21_linear_1414_3989)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5534 12.0201C17.2001 11.6667 19.06 11.8067 19.9067 12.3601C20.3467 12.6467 22.04 12.8467 21.1867 21.7534C20.26 22.6067 19.18 23.2934 18.0001 23.7734C20.5934 17.5534 18.06 12.5267 17.5534 12.0201Z",
    fill: "url(#paint22_linear_1414_3989)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8867 23.8199C22.3867 12.4866 20.4267 12.4333 19.9267 12.1666C19.04 11.6866 17.4867 11.5199 17.5533 12.0199C17.6267 12.5799 20.5534 13.12 19.2534 23.8199",
    fill: "url(#paint23_linear_1414_3989)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M19.7333 22.8667C19.9467 22.7267 20.22 22.7067 20.4467 22.8268C20.4467 22.8268 20.4467 22.8268 20.4533 22.8268C21.4667 23.3468 21.54 22.3668 22.5133 22.3534C23.3467 22.3401 25.2133 23.2267 24.38 23.8068C23.7467 24.2534 23.0133 23.7601 22.5467 24.0334C21.6467 24.5534 21.7 24.7134 20.94 24.4668C19.4933 23.9934 19.8133 24.5467 18.7733 24.7401C18.02 24.8801 17.1267 24.6267 16.7067 24.2001C17.7867 23.9134 18.8067 23.4601 19.7333 22.8667Z",
    fill: "url(#paint24_linear_1414_3989)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M21.8867 23.8199C22.3867 12.4866 20.4267 12.4333 19.9267 12.1666C19.04 11.6866 17.4867 11.5199 17.5533 12.0199C17.6267 12.5799 20.5534 13.12 19.2534 23.8199",
    fill: "url(#paint25_linear_1414_3989)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M21.8867 23.8199C22.3867 12.4866 20.4267 12.4333 19.9267 12.1666C19.04 11.6866 17.4867 11.5199 17.5533 12.0199C17.6267 12.5799 20.5534 13.12 19.2534 23.8199",
    fill: "url(#paint26_linear_1414_3989)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8867 23.8199C22.3867 12.4866 20.4267 12.4333 19.9267 12.1666C19.04 11.6866 17.4867 11.5199 17.5533 12.0199C17.6267 12.5799 20.5534 13.12 19.2534 23.8199",
    fill: "url(#paint27_linear_1414_3989)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.6667 13.8666C24.6667 19.7599 19.8934 24.5 14 24.5333C8.14671 24.5599 3.36003 19.78 3.33336 13.8666C3.3067 7.97327 8.1067 3.19995 14 3.19995C19.8934 3.19995 24.6667 7.97327 24.6667 13.8666Z",
    fill: "url(#paint28_radial_1414_3989)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1414_3989",
    x1: 9.92464,
    y1: 23.5711,
    x2: 6.67073,
    y2: 23.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3640FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308253,
    stopColor: "#3444FD",
    stopOpacity: 0.4846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1872E8",
    stopOpacity: 0.2655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#068EDB",
    stopOpacity: 0.0968231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1414_3989",
    x1: 7.15917,
    y1: 22.0464,
    x2: 7.34103,
    y2: 23.7251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2885,
    stopColor: "#7BD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#45C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8656,
    stopColor: "#24BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1414_3989",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9015 9.54379) scale(12.868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1414_3989",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9014 9.54382) scale(10.1239 10.1239)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1414_3989",
    x1: 12.9888,
    y1: 17.9118,
    x2: 3.59198,
    y2: 17.5324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1414_3989",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6302 18.4162) scale(2.84177)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1414_3989",
    x1: 10.0284,
    y1: 16.7348,
    x2: 17.9727,
    y2: 16.7348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1414_3989",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9182 16.4964) scale(2.80587 2.80587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9BCBE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1414_3989",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0012 19.9194) scale(3.03192 0.772905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C20000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1414_3989",
    x1: 9.69784,
    y1: 10.0071,
    x2: 9.66452,
    y2: 8.55157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1414_3989",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.82822 11.6164) rotate(-2.88189) scale(2.06194 0.916231)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1414_3989",
    x1: 9.90537,
    y1: 9.34367,
    x2: 9.90537,
    y2: 12.0267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1414_3989",
    x1: 18.3023,
    y1: 10.0071,
    x2: 18.3357,
    y2: 8.55157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1414_3989",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1703 11.6164) rotate(-177.118) scale(2.06194 0.916231)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1414_3989",
    x1: 18.0947,
    y1: 9.34367,
    x2: 18.0947,
    y2: 12.0267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1414_3989",
    x1: 7.3665,
    y1: 7.80059,
    x2: 8.90346,
    y2: 24.7491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3331,
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4126,
    stopColor: "#7BD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#45C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5715,
    stopColor: "#24BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#17BBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8891,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1414_3989",
    x1: 8.85394,
    y1: 24.3733,
    x2: 6.02058,
    y2: 23.3734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3640FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308253,
    stopColor: "#3444FD",
    stopOpacity: 0.4846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1872E8",
    stopOpacity: 0.2655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#068EDB",
    stopOpacity: 0.0968231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1414_3989",
    x1: 8.88732,
    y1: 13.0434,
    x2: 7.6429,
    y2: 19.1323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1414_3989",
    x1: 8.43379,
    y1: 20.2236,
    x2: 8.63378,
    y2: 23.2903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1414_3989",
    x1: 8.24178,
    y1: 21.7072,
    x2: 8.24178,
    y2: 10.9516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17BBFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0099D6",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1414_3989",
    x1: 18.0756,
    y1: 23.5712,
    x2: 21.3295,
    y2: 23.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3640FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308253,
    stopColor: "#3444FD",
    stopOpacity: 0.4846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1872E8",
    stopOpacity: 0.2655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#068EDB",
    stopOpacity: 0.0968231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1414_3989",
    x1: 20.8411,
    y1: 22.0464,
    x2: 20.6593,
    y2: 23.7251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2885,
    stopColor: "#7BD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#45C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8656,
    stopColor: "#24BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1414_3989",
    x1: 15.0115,
    y1: 17.9119,
    x2: 24.4084,
    y2: 17.5324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1414_3989",
    x1: 20.6338,
    y1: 7.80062,
    x2: 19.0969,
    y2: 24.7491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3331,
    stopColor: "#B0E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4126,
    stopColor: "#7BD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#45C9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5715,
    stopColor: "#24BFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6085,
    stopColor: "#17BBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8891,
    stopColor: "#17BBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1414_3989",
    x1: 19.1463,
    y1: 24.3733,
    x2: 21.9796,
    y2: 23.3734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3640FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308253,
    stopColor: "#3444FD",
    stopOpacity: 0.4846
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#1872E8",
    stopOpacity: 0.2655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8064,
    stopColor: "#068EDB",
    stopOpacity: 0.0968231
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1414_3989",
    x1: 19.113,
    y1: 13.0434,
    x2: 20.3575,
    y2: 19.1323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1414_3989",
    x1: 19.5666,
    y1: 20.2236,
    x2: 19.3666,
    y2: 23.2903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1414_3989",
    x1: 19.7586,
    y1: 21.7072,
    x2: 19.7586,
    y2: 10.9517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17BBFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0099D6",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1414_3989",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0919 22.5596) rotate(-90) scale(1.42222 4.44342)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3541E",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#B26126",
    stopOpacity: 0.3578
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8286,
    stopColor: "#DA843C",
    stopOpacity: 0.0836319
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#E89043",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/Sad.588923030b0227c3789231e026da3fa2.svg";
export { ForwardRef as ReactComponent };